// extracted by mini-css-extract-plugin
export var badge = "badge-module--badge--040b7";
export var label = "badge-module--label--cffaf";